"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75177],{

/***/ 73442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthButtonView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89213);





function AuthButtonView(param) {
    var iconUrl = param.iconUrl, text = param.text, _isFilled = param.isFilled, isFilled = _isFilled === void 0 ? false : _isFilled;
    var textColor = isFilled ? _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].black */ .Z.black : _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .ButtonContainer */ .qO, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .ButtonIcon */ .Ei, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    src: iconUrl,
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                color: textColor,
                size: "14px",
                family: "bold",
                children: text
            })
        ]
    });
};


/***/ }),

/***/ 72099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37949);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73502);
/* harmony import */ var _greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2497);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48028);
/* harmony import */ var _AuthButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73442);
/* harmony import */ var _assets_base64icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54392);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28456);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2915);












var fbAppId = "247631672013136";
function FacebookOauth(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "main" : _variant, _size = param.size, size = _size === void 0 ? "large" : _size, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var isLoading = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_slice__WEBPACK_IMPORTED_MODULE_9__/* .selectors */ .wl).isLoading;
    var textButton = "Register with Facebook";
    var handleCallback = {
        accessToken: "",
        success: function(response) {
            if (response === null || response === void 0 ? void 0 : response.accessToken) {
                handleCallback.accessToken = response.accessToken;
            }
        },
        profileSuccess: function(response) {
            if (handleCallback.accessToken !== "") {
                dispatch(_slice__WEBPACK_IMPORTED_MODULE_9__/* .effects.generateUsername */ .Sz.generateUsername((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    accessToken: handleCallback.accessToken
                }, response)));
            }
        }
    };
    var onCallClevertapEvent = function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_6__/* .clevertapEvent */ .Lq)("Register Selected", {
            "Register Method": _constants__WEBPACK_IMPORTED_MODULE_8__/* .registerTypes.FACEBOOK */ .E8.FACEBOOK
        });
    };
    var renderMainButton = function(onClick) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            id: "facebook-register",
            type: "facebook",
            height: "44px",
            loading: isLoading,
            // @ts-expect-error
            justifyContent: "start",
            block: true,
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                iconUrl: "/icon/register/icon-facebook.svg",
                text: textButton
            })
        });
    };
    var renderSecondaryButton = function(onClick) {
        var buttonHeight = "".concat(size === "medium" ? 30.8 : 44, "px");
        var iconSize = "".concat(size === "medium" ? 16.8 : 24, "px");
        var fontSize = "".concat(size === "medium" ? 9.8 : 14, "px");
        var iconPadding = isCompanyStock ? "10px" : "unset";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            id: "facebook-register",
            height: buttonHeight,
            loading: isLoading,
            // @ts-expect-error
            justifyContent: "start",
            block: true,
            round: true,
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            style: {
                paddingLeft: 20,
                paddingRight: 20
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    icon: _assets_base64icon__WEBPACK_IMPORTED_MODULE_11__/* .facebookIconBlue */ .$P,
                    iconSize: iconSize,
                    padding: iconPadding
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    color: "light",
                    size: fontSize,
                    family: "bold",
                    width: "100%",
                    align: "center",
                    children: textButton
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_4___default()), {
        appId: fbAppId,
        fields: "name,email,picture",
        onSuccess: handleCallback.success,
        onProfileSuccess: handleCallback.profileSuccess,
        render: function(param) {
            var onClick = param.onClick;
            if (variant === "secondary") {
                return renderSecondaryButton(onClick);
            }
            return renderMainButton(onClick);
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FacebookOauth);


/***/ }),

/***/ 79106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37949);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2497);
/* harmony import */ var react_google_login__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93645);
/* harmony import */ var react_google_login__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_google_login__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48028);
/* harmony import */ var assets_base64icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54392);
/* harmony import */ var _AuthButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73442);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84405);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28456);











var googleClientId = "867806581579-u0ubjbmo7u3ikv05j099paceeirj6olm.apps.googleusercontent.com";
function GoogleOauth(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "main" : _variant, _size = param.size, size = _size === void 0 ? "large" : _size, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var isLoading = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_slice__WEBPACK_IMPORTED_MODULE_8__/* .selectors */ .wl).isLoading;
    var textButton = "Register with Google";
    var onCallClevertapEvent = function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_6__/* .clevertapEvent */ .Lq)("Register Selected", {
            "Register Method": _constants__WEBPACK_IMPORTED_MODULE_9__/* .registerTypes.GOOGLE */ .E8.GOOGLE
        });
    };
    var handleOauthCallback = function(response) {
        if (!response.error) {
            dispatch(_slice__WEBPACK_IMPORTED_MODULE_8__/* .effects.generateUsername */ .Sz.generateUsername(response));
        }
    };
    var renderMainButton = function(onClick) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            id: "google-register",
            height: "44px",
            // @ts-expect-error
            mt: "10px",
            loading: isLoading,
            block: true,
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                iconUrl: "/icon/register/icon-google.svg",
                text: textButton,
                isFilled: true
            })
        });
    };
    var renderSecondaryButton = function(onClick) {
        var buttonHeight = "".concat(size === "medium" ? 30.8 : 44, "px");
        var iconSize = "".concat(size === "medium" ? 16.8 : 24, "px");
        var fontSize = "".concat(size === "medium" ? 9.8 : 14, "px");
        var icon = isCompanyStock ? assets_base64icon__WEBPACK_IMPORTED_MODULE_10__/* .newGoogleIcon */ .XT : assets_base64icon__WEBPACK_IMPORTED_MODULE_10__/* .googleIcon */ .HM;
        var iconPadding = isCompanyStock ? "10px" : "unset";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            block: true,
            // @ts-expect-error
            round: true,
            mb: "16px",
            height: buttonHeight,
            justifyContent: "start",
            loading: isLoading,
            id: "google-register",
            style: {
                paddingLeft: 20,
                paddingRight: 20
            },
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    icon: icon,
                    iconSize: iconSize,
                    padding: iconPadding
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    color: "light",
                    size: fontSize,
                    family: "bold",
                    width: "100%",
                    align: "center",
                    children: textButton
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_google_login__WEBPACK_IMPORTED_MODULE_5___default()), {
        clientId: googleClientId,
        buttonText: "Register",
        onSuccess: handleOauthCallback,
        onFailure: handleOauthCallback,
        cookiePolicy: "single_host_origin",
        className: "register-with-google-button hide",
        render: function(param) {
            var onClick = param.onClick;
            if (variant === "secondary") {
                return renderSecondaryButton(onClick);
            }
            return renderMainButton(onClick);
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (GoogleOauth);


/***/ }),

/***/ 89213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BH": function() { return /* binding */ RegisterStyle; },
/* harmony export */   "Ei": function() { return /* binding */ ButtonIcon; },
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "KM": function() { return /* binding */ InputPinContainer; },
/* harmony export */   "Pk": function() { return /* binding */ InputPhoneContainer; },
/* harmony export */   "Tc": function() { return /* binding */ InputPinWrapper; },
/* harmony export */   "cW": function() { return /* binding */ CustomStyle; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; }
/* harmony export */ });
/* unused harmony exports InputContainer, InputNumber, Spacer, TextInfo, Wrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-sizing: border-box;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 0 0 10px ",
        ";\n\n  @media ",
        " {\n    width: 100%;\n    padding: 20px 40px;\n  }\n\n  @media ",
        " {\n    width: 450px;\n    padding: 40px 70px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .phone-dropdown-button {\n    background-color: transparent !important;\n    border: none;\n\n    div {\n      border: none;\n    }\n\n    .arrow {\n      left: 24px;\n      border-left: 4px solid transparent;\n      border-right: 4px solid transparent;\n      border-top: 5px solid #555;\n    }\n  }\n\n  .phone-input {\n    font-size: 15px !important;\n    line-height: 19px;\n    font-weight: 700 !important;\n    color: #333333 !important;\n  }\n\n  .phone-input::placeholder {\n    font-weight: 400 !important;\n  }\n\n  button {\n    background: transparent;\n    border: none;\n    position: absolute;\n    right: 0;\n    top: 20%;\n    cursor: pointer;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  padding: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 30px;\n  margin-right: 10px;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  width: 45px;\n  font-size: 22px;\n  font-weight: bold;\n  text-align: center;\n  padding: 0;\n\n  :focus,\n  :hover {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Hide google recaptcha */\n    .grecaptcha-badge {\n      opacity: 1;\n      visibility: visible;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: ",
        "px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  align-self: stretch;\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: -20px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .register,\n  .login {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    border: none;\n\n    button.ant-btn {\n      border-radius: 4px;\n      padding: 5px 16px;\n    }\n\n    button.ant-btn-facebook {\n      background: #33579D;\n    }\n\n    button.btn-successful-register {\n      border-radius: 4px;\n    }\n\n    button.ant-btn-default {\n      border: 1px solid ",
        ";\n    }\n\n    button.ant-btn .ant-btn-loading-icon {\n      display: flex;\n    }\n\n    button:disabled, button:disabled:hover {\n      background-color: #8CD9BC !important;\n      border-color: #8CD9BC !important;\n\n      p {\n        color: ",
        " !important;\n      }\n    }\n\n    .form-divider {\n      margin: 10px 20px;\n      width: auto;\n      \n      p {\n        font-family: ProximaNovaLt;\n      }\n    }\n\n    @media ",
        " {\n      width: 100% !important;\n      padding: 28px 30px !important;\n    }\n\n    @media ",
        " {\n      width: 450px !important;\n      padding: 32px 40px !important;\n    }\n  }\n\n  .auth-text-container {\n    padding: 0;\n  }\n\n  .ant-message-notice.sysmsg-content {\n    max-width: 440px !important;\n  }\n\n  @media ",
        " {\n    .ant-tooltip-placement-leftTop {\n      display: none;\n    }\n\n    .ant-tooltip-hidden {\n      display: none !important;\n    }\n  }\n\n  @media ",
        " {\n    .ant-tooltip-placement-leftTop {\n      display: block;\n    }\n\n    .ant-tooltip-hidden {\n      display: none !important;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 24px 0 20px;\n\n  input {\n    border: none;\n    border-bottom: 1px solid ",
        ";\n    width: 35px;\n    height: 40px;\n    font-size: 24px;\n    font-weight: bold;\n    text-align: center;\n    outline: none;\n  }\n\n  input:focus,\n  input.filled {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lowgray */ .Z.lowgray, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet);
var InputPhoneContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-1"
})(_templateObject1());
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8b53bd67-2"
})(_templateObject2());
var InputContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-3"
})(_templateObject3());
var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8b53bd67-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var TextInfo = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8b53bd67-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dimGray */ .Z.dimGray);
var CustomStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .createGlobalStyle */ .vJ)(_templateObject6());
var Spacer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-6"
})(_templateObject8(), function(param) {
    var height = param.height;
    return height && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject7(), height);
});
var ButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-7"
})(_templateObject9());
var ButtonIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-8"
})(_templateObject10());
var InputPinContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-9"
})(_templateObject11());
var RegisterStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .createGlobalStyle */ .vJ)(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileL */ .Z.mobileL, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);
var InputPinWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-10"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);



/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountAbbrv3, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += "M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += "B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += "T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var nNumber = (number >= 0 ? Math.floor : Math.ceil)(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n1) {
    return Number(n1) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    // eslint-disable-next-line eqeqeq
    if (newNumber && newNumber.toString().indexOf("-") == 0) {
        minus = true;
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += "".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n1) {
    return !Number.isNaN(parseFloat(n1)) && Number.isFinite(n1);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += "".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(n))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal,
    parseCountAbbrv2: parseCountAbbrv2
});


/***/ })

}]);